"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pipenvAdd = void 0;
const pathLib = require("path");
const pipenvPipfileFix = require("@snyk/fix-pipenv-pipfile");
const debugLib = require("debug");
const validate_required_data_1 = require("../../validate-required-data");
const attempted_changes_summary_1 = require("../../attempted-changes-summary");
const command_failed_to_run_error_1 = require("../../../../../lib/errors/command-failed-to-run-error");
const no_fixes_applied_1 = require("../../../../../lib/errors/no-fixes-applied");
const debug = debugLib('snyk-fix:python:pipenvAdd');
async function pipenvAdd(entity, options, upgrades) {
    const changes = [];
    let pipenvCommand;
    const { remediation, targetFile } = (0, validate_required_data_1.validateRequiredData)(entity);
    try {
        const targetFilePath = pathLib.resolve(entity.workspace.path, targetFile);
        const { dir } = pathLib.parse(targetFilePath);
        if (!options.dryRun && upgrades.length) {
            const { stderr, stdout, command, exitCode } = await pipenvPipfileFix.pipenvInstall(dir, upgrades, {
                python: entity.options.command,
            });
            debug('`pipenv add` returned:', { stderr, stdout, command });
            if (exitCode !== 0) {
                pipenvCommand = command;
                throwPipenvError(stderr, stdout, command);
            }
        }
        changes.push(...(0, attempted_changes_summary_1.generateSuccessfulChanges)(upgrades, remediation.pin));
    }
    catch (error) {
        changes.push(...(0, attempted_changes_summary_1.generateFailedChanges)(upgrades, remediation.pin, error, pipenvCommand));
    }
    return changes;
}
exports.pipenvAdd = pipenvAdd;
function throwPipenvError(stderr, stdout, command) {
    const incompatibleDeps = 'There are incompatible versions in the resolved dependencies';
    const lockingFailed = 'Locking failed';
    const versionNotFound = 'Could not find a version that matches';
    const errorsToBubbleUp = [incompatibleDeps, lockingFailed, versionNotFound];
    for (const error of errorsToBubbleUp) {
        if (stderr.toLowerCase().includes(error.toLowerCase()) ||
            stdout.toLowerCase().includes(error.toLowerCase())) {
            throw new command_failed_to_run_error_1.CommandFailedError(error, command);
        }
    }
    const SOLVER_PROBLEM = /SolverProblemError(.* version solving failed)/gms;
    const solverProblemError = SOLVER_PROBLEM.exec(stderr) || SOLVER_PROBLEM.exec(stdout);
    if (solverProblemError) {
        throw new command_failed_to_run_error_1.CommandFailedError(solverProblemError[0].trim(), command);
    }
    throw new no_fixes_applied_1.NoFixesCouldBeAppliedError();
}
//# sourceMappingURL=pipenv-add.js.map